import type { OnPlayerDriveOver } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export abstract class LevelChangerThing extends PhysicalThing implements OnPlayerDriveOver {
	readonly destinationLevel: number;

	constructor(xy: XY, destinationLevel: number) {
		super(xy, false);
		this.destinationLevel = destinationLevel;
	}

	getZOrder(): number {
		return ZOrder.LEVEL_CHANGER;
	}

	isHideUnderneath(): boolean {
		return false;
	}

	onPlayerDriveOver(): void {
		if (!this.board) return;
		this.board.beginLevelTransition(this.destinationLevel);
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), destinationLevel: this.destinationLevel };
	}
}
